import type { ErrorComponentProps } from "@tanstack/solid-router"
import { ErrorComponent, Link, rootRouteId, useMatch, useRouter } from "@tanstack/solid-router"
import { Button } from "~/components/ui/button"

export function DefaultCatchBoundary({ error }: ErrorComponentProps) {
  const router = useRouter()
  const isRoot = useMatch({
    strict: false,
    select: (state) => state.id === rootRouteId
  })

  console.error("DefaultCatchBoundary Error:", error)

  return (
    <div class="flex min-w-0 flex-1 flex-col items-center justify-center gap-6 p-4">
      <ErrorComponent error={error} />
      <div class="flex flex-wrap items-center gap-2">
        <Button
          onClick={() => {
            router.invalidate()
          }}
          class={`rounded bg-gray-600 px-2 py-1 font-extrabold text-white uppercase dark:bg-gray-700`}
        >
          Try Again
        </Button>
        {isRoot() ? (
          <Link to="/" class={`rounded bg-gray-600 px-2 py-1 font-extrabold text-white uppercase dark:bg-gray-700`}>
            Home
          </Link>
        ) : (
          <Link
            to="/"
            class={`rounded bg-gray-600 px-2 py-1 font-extrabold text-white uppercase dark:bg-gray-700`}
            onClick={(e) => {
              e.preventDefault()
              window.history.back()
            }}
          >
            Go Back
          </Link>
        )}
      </div>
    </div>
  )
}
